import { createRoutine } from 'redux-saga-routines'
import { call, put, takeLatest, fork, select } from '@redux-saga/core/effects'
import * as whatsNewService from 'services/whatsNewService'

export const getWhatsNewRoutine = createRoutine('WHATS_NEW/GET_ALL')
export const getRecentWhatsNewRoutine = createRoutine('WHATS_NEW/GET_RECENT')
export const getWhatsNewStatusRoutine = createRoutine('WHATS_NEW/GET_STATUS')
export const markWhatsNewSeenRoutine = createRoutine('WHATS_NEW/MARK_SEEN')

// Same TTL pattern as tutorials — 4 components dispatch these on every mount
// (Navigation, WhatsNewModal, WhatsNewPanel, WhatsNewPage). Pass `{ force: true }` to bypass.
const WHATS_NEW_TTL_MS = 5 * 60 * 1000

function* fetchWhatsNew({ payload } = {}) {
  if (!payload?.force) {
    const lastFetchedAt = yield select(s => s.whatsNew?.lastFetchedAt || 0)
    const items = yield select(s => s.whatsNew?.items || [])
    if (items.length > 0 && Date.now() - lastFetchedAt < WHATS_NEW_TTL_MS) {
      return
    }
  }
  yield put(getWhatsNewRoutine.request())
  try {
    const { data } = yield call(whatsNewService.fetchWhatsNew)
    yield put(getWhatsNewRoutine.success(data))
  } catch (error) {
    yield put(getWhatsNewRoutine.failure(error))
  }
}

function* fetchRecentWhatsNew({ payload } = {}) {
  if (!payload?.force) {
    const lastFetchedAt = yield select(s => s.whatsNew?.recentLastFetchedAt || 0)
    const recent = yield select(s => s.whatsNew?.recent || [])
    if (recent.length > 0 && Date.now() - lastFetchedAt < WHATS_NEW_TTL_MS) {
      return
    }
  }
  yield put(getRecentWhatsNewRoutine.request())
  try {
    const { data } = yield call(whatsNewService.fetchRecentWhatsNew)
    yield put(getRecentWhatsNewRoutine.success(data))
  } catch (error) {
    yield put(getRecentWhatsNewRoutine.failure(error))
  }
}

function* fetchWhatsNewStatus() {
  yield put(getWhatsNewStatusRoutine.request())
  try {
    const { data } = yield call(whatsNewService.fetchWhatsNewStatus)
    yield put(getWhatsNewStatusRoutine.success(data))
  } catch (error) {
    yield put(getWhatsNewStatusRoutine.failure(error))
  }
}

function* markWhatsNewSeen() {
  console.log('%c[SAGA] markWhatsNewSeen triggered', 'color: orange; font-weight: bold')
  yield put(markWhatsNewSeenRoutine.request())

  try {
    const { data } = yield call(whatsNewService.markWhatsNewSeen)
    console.log('%c[SAGA] markWhatsNewSeen success', 'color: green; font-weight: bold', data)
    yield put(markWhatsNewSeenRoutine.success(data))
  } catch (error) {
    console.error('%c[SAGA] markWhatsNewSeen failed', 'color: red', error)
    yield put(markWhatsNewSeenRoutine.failure(error))
  }
}


function* watchGetWhatsNew() {
  yield takeLatest(getWhatsNewRoutine.TRIGGER, fetchWhatsNew)
}

function* watchGetRecentWhatsNew() {
  yield takeLatest(getRecentWhatsNewRoutine.TRIGGER, fetchRecentWhatsNew)
}

function* watchGetWhatsNewStatus() {
  yield takeLatest(getWhatsNewStatusRoutine.TRIGGER, fetchWhatsNewStatus)
}

function* watchMarkWhatsNewSeen() {
  yield takeLatest(markWhatsNewSeenRoutine.TRIGGER, markWhatsNewSeen)
}

export const whatsNewSagas = [
  fork(watchGetWhatsNew),
  fork(watchGetRecentWhatsNew),
  fork(watchGetWhatsNewStatus),
  fork(watchMarkWhatsNewSeen),
]
